import React from 'react';
import PropTypes from 'prop-types';

class MagnifyingGlassIcon extends React.PureComponent {
	render() {
		const { width, height, fill } = this.props;

		const viewBox = [0, 0, width, height].join(' ');

		return (
			<svg width={width} height={height} viewBox={viewBox} xmlns="http://www.w3.org/2000/svg">
				<title>Magnifying Glass Icon</title>
				<g id="8-resources-library" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
					<g
						id="8-all"
						transform="translate(-554.000000, -300.000000)"
						fill={fill}
						fillRule="nonzero"
					>
						<g id="hero" transform="translate(0.000000, 102.000000)">
							<g id="field" transform="translate(135.000000, 183.000000)">
								<g id="search">
									<g id="button" transform="translate(404.000000, 0.000000)">
										<path
											d="M26.8302676,23.9740764 C27.2201476,23.6320748 27.5126655,23.2458629 27.7076363,22.8156028 C27.9025146,22.3853428 28,21.9468085 28,21.5 C28,21.0531915 27.9025454,20.6118991 27.7076363,20.1761229 C27.5126655,19.7403467 27.2201168,19.3514578 26.8302676,19.0094563 C26.440326,18.6674547 25.9999769,18.4137116 25.5094977,18.248227 C25.0189259,18.0827423 24.5157755,18 24.0000462,18 C23.4842862,18 22.9810741,18.0827423 22.4905948,18.248227 C22.0000231,18.4137116 21.5597665,18.6674547 21.1698248,19.0094563 C20.7798832,19.3514578 20.487427,19.7403467 20.2924562,20.1761229 C20.0974854,20.6118991 20,21.0531915 20,21.5 C20,21.9468085 20.0974854,22.3853428 20.2924562,22.8156028 C20.487427,23.2458629 20.7798832,23.6319937 21.1698248,23.9740764 C21.5597665,24.3160239 22.0000231,24.5725791 22.4905948,24.7435799 C22.9811665,24.9144996 23.484317,25 24.0000462,25 C24.5157755,25 25.0189259,24.9144996 25.5094977,24.7435799 C26.0000694,24.5725521 26.440326,24.3160509 26.8302676,23.9740764 Z M29.0088889,16.9282888 C29.6726797,17.5768615 30.1703704,18.3094012 30.5022222,19.1259079 C30.8340741,19.9424146 31,20.7733984 31,21.6188592 C31,22.4643201 30.8340741,23.2953038 30.5022222,24.1118105 C30.1703704,24.9283172 29.6725926,25.6608569 29.0088889,26.3094296 C28.4756427,26.8306041 27.882963,27.2475437 27.2311111,27.5602484 C26.5793174,27.8729531 25.9037908,28.0813377 25.2044444,28.1855726 C24.5051852,28.2898927 23.802963,28.2841018 23.0978068,28.1682853 C22.3926216,28.0524687 21.7199419,27.8324173 21.080029,27.5081309 L18.0222222,30.496198 C17.8444444,30.6699228 17.6488889,30.7972359 17.4355556,30.8783926 C17.2222222,30.9594642 17,31 16.7688889,31 C16.5377778,31 16.3155556,30.9594642 16.1022222,30.8783926 C15.8888889,30.797321 15.6933333,30.6699228 15.5155556,30.496198 C15.3377778,30.3224732 15.2074074,30.1313759 15.1244444,29.9229061 C15.0414815,29.7144363 15,29.4972802 15,29.2714379 C15,29.0455957 15.0414815,28.8284964 15.1244444,28.620055 C15.2074074,28.4115 15.3377778,28.2204879 15.5155556,28.0467631 L18.4666667,25.1629309 C18.0518519,24.5259399 17.7614815,23.842537 17.5955556,23.1129211 C17.4296296,22.3832485 17.3851852,21.6536042 17.4622222,20.9240451 C17.5392593,20.1944008 17.7407407,19.4850244 18.0666667,18.7959159 C18.3925926,18.1068074 18.84,17.4842934 19.4088889,16.928374 C20.0725926,16.291383 20.8222222,15.8107443 21.6577778,15.4864579 C22.4933333,15.1621432 23.3437037,15 24.2089179,15 C25.074016,15 25.9244735,15.1621432 26.7599419,15.4864295 C27.5955846,15.8106591 28.3451852,16.2912978 29.0088889,16.9282888 Z"
											transform="translate(23.000000, 23.000000) rotate(-90.000000) translate(-23.000000, -23.000000) "
										/>
									</g>
								</g>
							</g>
						</g>
					</g>
				</g>
			</svg>
		);
	}
}

MagnifyingGlassIcon.defaultProps = {
	width: 16,
	height: 16,
	fill: '#fff',
};

MagnifyingGlassIcon.propTypes = {
	width: PropTypes.number,
	height: PropTypes.number,
	fill: PropTypes.string,
};

export default MagnifyingGlassIcon;



// WEBPACK FOOTER //
// ./src/components/shared/icons/magnifyingGlassIcon.js